import { useNavigate } from "react-router-dom";
import {
  ArrowForward,
  Inventory2Outlined,
  CloudOutlined,
  QrCodeScannerOutlined,
  PointOfSaleOutlined,
  CheckCircleOutline,
  AutoAwesome,
} from "@mui/icons-material";
import "./UniverseCTA.css";

const UniverseCTA = () => {
  const navigate = useNavigate();
  return (
    <section className="universeCTA">
      <div className="universeCTA__background">
        <div className="universeCTA__orb universeCTA__orb--one"></div>
        <div className="universeCTA__orb universeCTA__orb--two"></div>
        <div className="universeCTA__grid"></div>
      </div>

      <div className="universeCTA__container">

        {/* TOP LABEL */}
        <div className="universeCTA__eyebrow fx-ac fx-jc space">
          <AutoAwesome />
          <span>THE UNIVERSE INVENTORY ECOSYSTEM</span>
        </div>

        {/* MAIN CONTENT */}
        <div className="universeCTA__content">

          <div className="universeCTA__heading">
            <h2>
              Everything your business needs
              <span> to stay in control.</span>
            </h2>

            <p>
              Manage inventory, process sales, scan products, receive
              real-time notifications and keep your business connected —
              all through one powerful ecosystem built for modern businesses.
            </p>
          </div>

          {/* CTA BUTTONS */}
          <div className="universeCTA__actions fx-ac fx-jc space1">

            <button
              type="button"
              className="universeCTA__primary fx-ac fx-jc space"
              onClick={() => (window.location.href = "/register")}
            >
              <span>Start Your Journey</span>
              <ArrowForward />
            </button>

            <button
              type="button"
              className="universeCTA__secondary fx-ac fx-jc space"
              onClick={() => (window.location.href = "/solutions/all-solutions")}
            >
              <span>Explore Universe</span>
            </button>

          </div>

          {/* TRUST MESSAGE */}
          <div className="universeCTA__trust fx-ac fx-jc space1">
            <div className="fx-ac space">
              <CheckCircleOutline />
              <span>Built for growing businesses</span>
            </div>

            <div className="fx-ac space">
              <CheckCircleOutline />
              <span>One connected ecosystem</span>
            </div>

            <div className="fx-ac space">
              <CheckCircleOutline />
              <span>Real-time business visibility</span>
            </div>
          </div>

        </div>

        {/* ECOSYSTEM CARDS */}
        <div className="universeCTA__ecosystem">

          <div className="universeCTA__product universeCTA__product--main">
            <div className="universeCTA__productIcon fx-ac fx-jc">
              <Inventory2Outlined />
            </div>

            <div className="universeCTA__productContent">
              <span className="universeCTA__productLabel">
                CORE PLATFORM
              </span>

              <h3>Universe Inventory</h3>

              <p>
                Your central command center for inventory, products,
                transactions, reporting and business operations.
              </p>
            </div>

            <ArrowForward className="universeCTA__productArrow" />
          </div>

          <div className="universeCTA__product">
            <div className="universeCTA__productIcon fx-ac fx-jc">
              <PointOfSaleOutlined />
            </div>

            <div className="universeCTA__productContent">
              <span className="universeCTA__productLabel">
                POINT OF SALE
              </span>

              <h3>Universe POS</h3>

              <p>
                Turn every sale into a connected inventory transaction.
              </p>
              <button type="button" className="universeCTA__appLink"
                onClick={() => navigate("/store/universe-mobile/application/universe-pos")}>
                Explore Universe POS <ArrowForward fontSize="small" />
              </button>
            </div>
          </div>

          <div className="universeCTA__product">
            <div className="universeCTA__productIcon fx-ac fx-jc">
              <QrCodeScannerOutlined />
            </div>

            <div className="universeCTA__productContent">
              <span className="universeCTA__productLabel">
                SMART SCANNING
              </span>

              <h3>Universe Scanner</h3>

              <p>
                Connect mobile barcode and QR scanning to Universe POS.
              </p>
              <button type="button" className="universeCTA__appLink"
                onClick={() => navigate("/store/universe-mobile/application/universe-scanner")}>
                Explore Universe Scanner <ArrowForward fontSize="small" />
              </button>
            </div>
          </div>

          <div className="universeCTA__product">
            <div className="universeCTA__productIcon fx-ac fx-jc">
              <CloudOutlined />
            </div>

            <div className="universeCTA__productContent">
              <span className="universeCTA__productLabel">
                REAL-TIME CONNECTION
              </span>

              <h3>UniCloud</h3>

              <p>
                Stay informed with real-time business notifications,
                similar to the simplicity of modern messaging apps.
              </p>
              <button type="button" className="universeCTA__appLink"
                onClick={() => navigate("/store/universe-mobile/application/unicloud")}>
                Explore UniCloud <ArrowForward fontSize="small" />
              </button>
            </div>
          </div>

        </div>

        {/* BOTTOM STATEMENT */}
        <div className="universeCTA__bottom">
          <div className="universeCTA__bottomLine"></div>

          <span>
            One platform. Multiple tools. One connected business.
          </span>

          <div className="universeCTA__bottomLine"></div>
        </div>

      </div>
    </section>
  );
};

export default UniverseCTA; 
